import { NgModule } from '@angular/core';
import { FiGradientTimerComponent } from './fi-gradient-timer.component';
import { FiGradientTimerService } from './fi-gradient-timer.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FiGradientCircleModule } from '../fi-gradient-circle/fi-gradient-circle.module';

@NgModule({
    imports: [CommonModule, MatIconModule, FiGradientCircleModule],
    declarations: [FiGradientTimerComponent],
    providers: [FiGradientTimerService],
    exports: [FiGradientTimerComponent],
})
export class FiGradientTimerModule {}
